var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('h4',[_vm._v("Offene Aufgaben")]),_c('div',{staticClass:"container"},[_c('ul',{staticClass:"list-group-item"},_vm._l((_vm.tasks),function(t){return _c('li',{key:t.id,staticClass:"list-group-item d-flex justify-content-between"},[_vm._v(" "+_vm._s(t.name)+" "),_c('small',[_vm._v(_vm._s(t.created))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }